import React from 'react';
import { SearchIcon } from '../../icons/FontAwesomeIcon';

export default function Searchbar({
    id,
    placeholder = 'Search for events, interests or activities.',
    value = '',
    onChange = () => {},
    containerStyle = {},
    inputStyle = {},
    iconStyle = {},
    onKeyDown = () => {}
}) {
    return (
        <div style={{ ...styles.container, ...containerStyle }}>
            <SearchIcon style={{ ...styles.icon, ...iconStyle }} />
            <input
                id={id}
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                style={{ ...styles.input, ...inputStyle }}
                onKeyDown={onKeyDown}
            />
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        border: 'none',
        borderRadius: '30px',
        padding: '5px 10px',
        width: '100%',
        // maxWidth: '500px',
        height: '100%',
        backgroundColor: '#F5F5F5'
    },
    input: {
        width: '100%',
        height: '100%',
        border: 'none',
        outline: 'none',
        padding: '5px',
        fontSize: '1.125rem',
        fontFamily: 'Noto Sans, sans-serif',
        backgroundColor: 'transparent',
        fontWeight: 400,
        color: '#11203A'
    },
    icon: {
        color: '#11203A'
    }
};

// Add this when reuse this component to handle searching
// const [searchQuery, setSearchQuery] = useState('');
//     const handleSearch = (e) => {
//         setSearchQuery(e.target.value);
//         console.log(e.target.value);
//     };
